import { paginationSize } from '../../../constants/constants';
import { FETCH_LOCKED_VISITS_ERROR, FETCH_LOCKED_VISITS_START, FETCH_LOCKED_VISITS_SUCCESS, SET_LOCKED_VISITS_PAGINATION } from "../../actions/groupadmin/lockedActions";


const INIT_STATE = {
    locked: [],
    loading: false,
    message: '',
    error: '',
    pagination: {
        currentPage: 1,
        pageSize: paginationSize,
        totalPages: 0,
        totalItems: 0,
    },
    searchFilter: {
        searchText: "",
        risId: 1,
        mipIds: [],
        modalityIds: [],
    },
    sortConditions: [{ sortBy: "visitStart", dataType: "DATE", sortType: "desc" }]
}

export const lockedReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case FETCH_LOCKED_VISITS_START:
            return { ...state, error: '', message: '', loading: true }

        case FETCH_LOCKED_VISITS_SUCCESS:
            return { ...state, error: '', message: '', loading: false, locked: action.locked.length > 0 ? [...action.locked] : [] }

        case SET_LOCKED_VISITS_PAGINATION: {
            return { ...state, pagination: action.pagination };
        }

        case FETCH_LOCKED_VISITS_ERROR:
            return { ...state, loading: false, error: '' }
        default:
            return state;
    }
}

export default lockedReducer;